import { AfterViewChecked, Component, inject, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AppTitleService } from '../../services/app-title.service';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { NgxExtendedPdfViewerModule, NgxExtendedPdfViewerService } from 'ngx-extended-pdf-viewer';
import { AnexoService } from '../../services/anexo.service';
import { DocumentoService } from '../../services/documento.service';
import { CategoriaPipe } from '../../pipes/categoria.pipe';
import { TipificacionPipe } from '../../pipes/tipificacion.pipe';
import { RecorridoDocumento } from '../../models/Document';
import { Anexo } from '../../models/Anexo';
import { MatDialog } from '@angular/material/dialog';
import { DateService } from '../../shared/date.service';
import { MatListModule } from '@angular/material/list';
import { DlgCommentConfirmComponent } from '../../commons/dlg-comment-confirm/dlg-comment-confirm.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../commons/toast.service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DocumentoEstadoPipe } from '../../pipes/documento-estado.pipe';
import { MatMenuModule } from '@angular/material/menu';
import { DlgConfirmComponent, DlgConfirmComponentData } from '../../commons/dlg-confirm/dlg-confirm.component';
import { Location, NgClass } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentoTareasComponent } from "../../commons/documento-tareas/documento-tareas.component";
import { TareaService } from '../../services/tarea.service';
import { NuevaTarea } from '../../models/Tarea';
import { AuthService } from '../../services/auth.service';
import { AnexosFullComponent } from "../../commons/anexos-full/anexos-full.component";
import { DlgCerrarTareasElaboracionComponent } from '../../commons/dlg-cerrar-tareas-elaboracion/dlg-cerrar-tareas-elaboracion.component';
import { DlgFirmaConjuntaCrearTareasComponent } from '../../commons/dlg-firma-conjunta-crear-tareas/dlg-firma-conjunta-crear-tareas.component';
import { UtilService } from '../../services/util.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { InteractiveOrgChartComponent } from '../interactive-org-chart/interactive-org-chart.component';
import { NoResultComponent } from "../../commons/no-result/no-result.component";
import { DlgRecuperarComponent } from '../../commons/dlg-recuperar/dlg-recuperar.component';
import { finalize, tap } from 'rxjs';

@Component({
  selector: 'app-resumen',
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    MatTabsModule,
    NgxExtendedPdfViewerModule,
    CategoriaPipe, TipificacionPipe,
    MatListModule, MatCheckboxModule, MatRadioModule,
    MatTableModule,
    RouterLink,
    MatMenuModule, MatProgressBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    NgClass,
    DocumentoTareasComponent,
    InteractiveOrgChartComponent,
    MatTooltipModule,
    AnexosFullComponent,
    NoResultComponent
  ],
  templateUrl: './resumen.component.html',
  styleUrl: './resumen.component.scss'
})
export class ResumenComponent implements AfterViewChecked {
  utilService = inject(UtilService)
  idTarea = this.route.snapshot.params["id"];
  /* isEdit = this.route.snapshot.url[0].path === "finalizar" */;
  isEdit = false;
  idAnexo = 0;
  firstLoadPdf = true;
  reply = false;
  zoomLevels = ['auto', 'page-actual', 'page-fit', 'page-width', 0.33, 0.5, 0.75, 1, 1.25, 1.5, 2];
  zoomSetting: number | string | undefined = 'auto';
  currentZoomFactor: number = 0;
  filePdf?: any;
  documento?: any;
  loadPdf = false;
  hasSignature = false;
  tokenData: any = this.authServ.getTokenData();
  loading = true;
  dataFound = true;

  @ViewChild(InteractiveOrgChartComponent) orgChart!: InteractiveOrgChartComponent;
  /**
   * Estado de la tarea
   * -1- TEMPORAL
   * 0 - NOABIERTO
   * 1 - ENPROGRESO
   * 2 - CERRADO
   * 3 - EXPIRADO
   * 4 - ANULADO
   * 5 - FINALIZADA
   * 6 - POREXPIRAR_NOABIERTO
   * 7 - POREXPIRAR_ENPROGRESO
   */
  permisos = {
    "enviar": [0],
    "responder": [0, 1],
    "reasignar": [0, 1],
    "tarea": [0, 1],
    "archivar": [0, 1, 2],
    "comentar": [0, 1, 2],
    "recuperar": [2],
    "alcance": [2],
  }
  tipoAtencion = {
    "responder": [],
    "reasignar": [],
    "tarea": [1, 2],
    "archivar": [1, 2],
    "comentar": [1, 2],
  }

  anexos: Anexo[] = []
  anexosOficios: Anexo[] = []
  anexosDocs: Anexo[] = []

  documentRoute: RecorridoDocumento[] = []
  documentRouteAcciones: RecorridoDocumento[] = []
  documentRouteComentarios: RecorridoDocumento[] = []
  displayedColumns: string[] = ['fechaHora', 'de', 'accion', 'dias', 'tareas', 'comentario'];
  documentRouteDataSource = new MatTableDataSource<RecorridoDocumento>([])
  documentRouteAccionesDataSource = new MatTableDataSource<RecorridoDocumento>([])
  documentRouteComentariosDataSource = new MatTableDataSource<RecorridoDocumento>([])

  fetchingDocumentClose = false
  snackbarData: ScnackbarData = {}

  documentoTareas!: NuevaTarea[]
  tipoTarea = 1;
  bandejaIndex: number = 0
  auxBandejaIndex = 0

  hasParticipated = false
  isOwner = false

  estadoTarea: number = -1
  tareasMostrarTodo = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dlg: MatDialog,
    private anexoServ: AnexoService,
    private documentoServ: DocumentoService,
    public pdfService: NgxExtendedPdfViewerService,
    private dateService: DateService,
    private location: Location,
    private toast: ToastService,
    private appTitleService: AppTitleService,
    private authServ: AuthService,
    private tareasService: TareaService,
    private utilServ: UtilService
  ) {
    inject(AppTitleService).setTitle("Resumen Documento ");

    const navigation = this.router.getCurrentNavigation()
    if (navigation) {
      this.auxBandejaIndex = navigation?.extras.state?.["bandejaIndex"]
    }
    this.documentoServ.getById(this.idTarea).subscribe({
      next: (res: any) => {
        this.documento = res;
        this.documento.fecha = this.formatDate(this.documento.fecha)
        this.appTitleService.setTitle("Resumen Documento: " + this.documento.anio + "-" + this.documento.numero);
        this.anexos = this.documento.anexos
        if (this.documento.tipoAtencion === 2 && this.documento.usuarioAnterior === this.tokenData.sub) {
          this.tipoTarea = 2;
        }
        this.fetchDocumentRoute()

        this.isEdit = this.documento.estadoTarea === 0

        this.utilServ.getParticipacionUsuarioDocumento(this.documento.id).subscribe({
          next: (_) => {
            this.hasParticipated = true
          },
          error: (_) => {
            this.hasParticipated = false
          }
        })

        this.estadoTarea = this.documento.estadoTarea

        if (this.documento.tipoAsignado === 1 && this.documento.participanteReasigna) {
          this.isOwner = this.documento.participanteReasigna == this.tokenData.id
        } else {
          this.isOwner = this.documento.codigoParticipante == this.tokenData.id
        }

        this.anexoServ.getDocumentByIdTarea(this.idTarea)
          .subscribe({
            next: (res: Anexo) => {
              this.idAnexo = res.id || 0;
              this.anexoServ.get(res.id || 0).subscribe({
                next: (res: Blob) => {
                  this.filePdf = res;
                }
              });
            }
          });

        this.fetchDocumentTasks()
        this.loading = false;
        this.dataFound = true;
      }, error: (err: HttpErrorResponse) => {
        //this.toast.show({ message: 'Error cargando documento', style: SnackbarStyles.Error });
        this.dataFound = false;
        this.loading = false;
        console.log("aki");
      }
    });


  }

  ngAfterViewChecked(): void {
    const control = document.getElementById("txtPage");
    if (control && control.childElementCount > 1) {
      control?.lastChild?.remove();
    }
  }

  loadDataGrafico(): void {
    this.orgChart.loadTareas();
  }


  mostrarTodo(e: any) {
    this.fetchDocumentTasks(e.checked ? 1 : 0);
  }

  onRenderPage() {
    if (this.firstLoadPdf) {
      this.btnZoomIn = document.getElementById('primaryZoomIn');
      this.btnZoomOut = document.getElementById('primaryZoomOut');
      let elBtnOut: HTMLElement = <HTMLElement>document.getElementById('primaryZoomIn');
      elBtnOut.click();
      let elBtnIn: HTMLElement = <HTMLElement>document.getElementById('primaryZoomOut');
      elBtnIn.click();
      this.firstLoadPdf = false;
    }

    this.loadPdf = true;
    try {
      let el: HTMLElement = <HTMLElement>document.getElementsByClassName('page')[0];
      el.style["margin"] = "0 auto";
      let container: any = <HTMLElement>document.getElementById('outerContainer');
      container.style['min-height'] = "256px";
      this.bandejaIndex = this.auxBandejaIndex
    } catch (err) { }
  }

  loadingRecorrido = false
  fetchDocumentRoute(id?: number) {
    const idTareaNode = (id) ? id : this.idTarea
    this.loadingRecorrido = true;
    this.documentoServ.getDocumentRoute(idTareaNode).subscribe({
      next: (response) => {
        setTimeout(() => {
          this.loadingRecorrido = false
        }, 500);
        this.documentRoute = response

        // Separar por tipo: 1=Acciones, 0=Comentarios
        this.documentRouteAcciones = response.filter(r => r.tipo === 1)
        this.documentRouteComentarios = response.filter(r => r.tipo === 0)

        this.documentRouteAccionesDataSource.data = this.documentRouteAcciones
        this.documentRouteComentariosDataSource.data = this.documentRouteComentarios
      }
    })
  }

  loadingAnexos = false
  idTareaAnexos: number = 0;
  refreshAnexosRecorrido(id: number) {
    this.idTareaAnexos = id;
    this.loadingAnexos = true
    this.anexoServ.getAnexosRamal(id).subscribe({
      next: (response) => {
        setTimeout(() => {
          this.loadingAnexos = false
        }, 500);
        this.anexos = response
      }, error: (error: HttpErrorResponse) => {
        this.loadingAnexos = false
        console.log(error)
      }
    })
    this.fetchDocumentRoute(id)
  }

  loadingTareas = false;
  fetchDocumentTasks(todos: number = 0) {
    this.loadingTareas = true;
    this.tareasService.getTareasByTareaID(this.idTarea, todos).subscribe({
      next: (response) => {
        this.documentoTareas = response
        const pendientes = this.documentoTareas.find(el => (el.estado === 0));
        this.reply = this.documentoTareas.length == 0 || pendientes == null;
        this.loadingTareas = false;
      }, error: (error: HttpErrorResponse) => {
        this.loadingTareas = false;
      }
    })
  }

  anexosRefreshHandler(result: Anexo[] | undefined) {
    if (result) {
      result.forEach((anexo) => {
        const exists = this.anexos.some(existingAnexo => existingAnexo.id === anexo.id);
        if (!exists) {
          this.anexos = [...this.anexos, anexo];
          this.anexosDocs = [...this.anexosDocs, anexo];
        }
      });
      this.fetchDocumentTasks()
    }
  }

  successRefreshHandler(success: boolean, todos: number = 0) {
    if (success) {
      this.fetchDocumentTasks(todos)
    }
  }

  onEdit() {
    this.router.navigateByUrl("/editar/" + this.idTarea);
  }

  onReply() {
    this.router.navigateByUrl("recibidos/responder/" + this.idTarea)
  }

  onAlcanceDocumento() {
    this.router.navigateByUrl("alcance/" + this.idTarea)
  }

  onReasign() {
    const taskData = {
      documentIDs: [parseInt(this.idTarea)]
    }

    this.router.navigateByUrl("/documento/reasignar", { state: taskData })
  }

  onToDirect() {
    const taskData = {
      documentIDs: [parseInt(this.idTarea)]
    }

    this.router.navigateByUrl("/documento/direccionar", { state: taskData })
  }

  onNewtask() {
    const taskData = {
      documentIDs: [parseInt(this.idTarea)]
    }

    this.router.navigateByUrl("/tarea", { state: taskData })
  }

  onAddComment() {
    const taskData = {
      documentIDs: [parseInt(this.idTarea)]
    }
    this.router.navigateByUrl("comentar", { state: taskData })
  }

  onRecuperar() {
    const dialogRef = this.dlg.open(DlgRecuperarComponent, {
      maxWidth: "40vw",
      width: "400px",
      data: { "idTarea": this.idTarea }
    })

    dialogRef.afterClosed().subscribe((result: string | undefined) => {
      if (result) {
        const snackbarData: ScnackbarData = {
          message: "Documento recuperado",
          style: SnackbarStyles.Success,
          iconName: "check_circle"
        }
        this.toast.show(snackbarData)
        const result = this.documento.anexos.filter((anexo: Anexo) => anexo.tipo === 0 && anexo.tarea == this.idTarea);
        this.utilServ.callTasks();
        this.router.navigateByUrl((result.length > 0 ? "/borrador" : "/recibido"));
      } else {
      }
    });
  }

  archivar() {
    const taskData = {
      documentIDs: [parseInt(this.idTarea)]
    }
    this.router.navigateByUrl("/documento/archivar", { state: taskData })
  }

  onFirmaConjunta() {
    const dialogRef = this.dlg.open(DlgFirmaConjuntaCrearTareasComponent, {
      maxWidth: "40vw",
      width: "400px",
      data: { "idTarea": this.idTarea }
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.fetchDocumentTasks()
      }
    });
  }

  onSendDocument() {
    const data: DlgConfirmComponentData = {
      title: "Enviar sin firmar?",
      message: "Est\xe1 seguro que desea enviar el documento sin firma electr\xf3nica?",
      confirmLabel: "Si, enviar sin firmar",
      closeLabel: "No"
    }
    const dialogRef = this.dlg.open(DlgConfirmComponent, {
      maxWidth: "40vw",
      width: "400px",
      data: data
    })
    dialogRef.afterClosed().subscribe((result: boolean | undefined) => {
      if (result) {
        this.fetchingDocumentClose = true
        this.documentoServ.cerrarDocumento(this.idTarea).subscribe({
          next: (_) => {
            const snackbarData: ScnackbarData = {
              message: "Documento enviado",
              style: SnackbarStyles.Success,
              iconName: "check_circle"
            }
            this.utilService.callTasks();
            this.toast.show(snackbarData)
            this.router.navigateByUrl("/enviado")
          }
        })
      }
    })
  }

  onDelete() {
    const dialogRef = this.dlg.open(DlgCommentConfirmComponent, {
      maxWidth: "40vw",
      width: "400px"
    });
    dialogRef.afterClosed().subscribe((result: string | undefined) => {
      if (result) {
        this.documentoServ.delete(this.idTarea, result).subscribe({
          next: (_) => {
            this.utilService.callTasks();
            const snackbarData: ScnackbarData = {
              message: "Registro eliminado",
              style: SnackbarStyles.Success,
              iconName: "check_circle"
            }
            this.toast.show(snackbarData)
            this.router.navigateByUrl("/borrador")
          }
        })
      }
    });
  }

  onClickEdit() {
    if (this.permisos.enviar.includes(this.documento?.estadoTarea) && this.reply) {
      return this.onEdit()
    }
    const dialogRef = this.dlg.open(DlgCerrarTareasElaboracionComponent, {
      maxWidth: "40vw",
      width: "400px",
      data: this.idTarea
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.onEdit()
      }
    });
  }

  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDate(date!)
  }

  dataGrafCargado = false
  onTabChange(event: MatTabChangeEvent) {
    (event.index);
    if (event.index === 1 && !this.dataGrafCargado) {
      this.loadDataGrafico();
      this.dataGrafCargado = true
    }
  }

  onBack() {
    this.location.back();
  }

  btnZoomIn?: HTMLElement | null;
  btnZoomOut?: HTMLElement | null;
  public zoomIn(): void {
    this.btnZoomIn?.click();
  }
  public zoomOut(): void {
    this.btnZoomOut?.click();
  }
}
